export default __webpack_public_path__ + "static/media/item5.6d9bfdb2.jpg";